import React from 'react';
// import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

function N20(props) {
    const {
        t,
        // i18n,
        time = "",
    } = props;

    return (
        <div>
            <h3>{t("messenger:notifications.N20.title")}</h3>
            <div className="sep-15" />
            <span className="dateTime">{time}</span>
            <div className="sep-10" />
            <div>
                {t("messenger:notifications.N20.msg")}
                <div className="sep-10" />
                {t("messenger:general.thank_you_3")}
            </div>
        </div>
    )
}
export default withTranslation()(N20);